import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FolderWorkflowStepsSnapshot } from 'src/app/models/server/folder-workflow-steps-snapshot';

@Component({
    imports: [DatePipe, FaIconComponent],
    templateUrl: './table-workflow-cell-tooltip.component.html',
    styleUrl: './table-workflow-cell-tooltip.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableWorkflowCellTooltipComponent implements OnInit {
    public deadlineStatusIcon = faCircle;

    @Input() data: FolderWorkflowStepsSnapshot;

    stepIsOutdated: boolean = false;
    delay: string;

    constructor() {}

    ngOnInit(): void {
        if (this.data) {
            let elapsedTimeSinceStepStartInMilliseconds = 0;
            // Si c'est une étape terminée
            if (this.data.completed) {
                // S'il s'agit d'une étape terminée, le délai correpond à la différence entre la date du dernier changement d'état "currentStateDate" et la date du début de l'étape "stepStartDate"
                elapsedTimeSinceStepStartInMilliseconds = new Date(this.data.currentStateDate).getTime() - new Date(this.data.stepStartDate).getTime();
            } else {
                // S'il s'agit d'une étape en cours, le délai correpond à la différence entre la date du jour et la date du début de l'étape "stepStartDate"
                elapsedTimeSinceStepStartInMilliseconds = new Date().getTime() - new Date(this.data.stepStartDate).getTime();
            }

            let elapsedTimeSinceStepStartInMinuts = Math.floor(elapsedTimeSinceStepStartInMilliseconds / (1000 * 60));

            if (elapsedTimeSinceStepStartInMinuts <= this.data.stepMaxDuration) {
                // Si le délai écoulé depuis le début de l'étape est <= à la durée maximale de l'étapePas de retard de l'étape --> il n'y a pas de retard.
                this.stepIsOutdated = false;
            } else {
                this.stepIsOutdated = true;
                // Calcul du retard
                this.delay = this.formatTime(elapsedTimeSinceStepStartInMinuts - this.data.stepMaxDuration);
            }
        }
    }

    private formatTime(time: number): string {
        if (!time || time === 0) {
            return '';
        }

        const minuts = time % 60;
        const totalHours = Math.floor(time / 60);
        const remainingHours = totalHours % 24;
        const totalDays = Math.floor(totalHours / 24);
        const remainingDays = totalDays % 7;
        const weeks = Math.floor(totalDays / 7);

        let format: string = '';

        if (weeks > 0) {
            format += `${weeks} semaine(s)`;
        }

        if (remainingDays > 0) {
            if (format.length !== 0) {
                format += ' ';
            }
            format += `${remainingDays} jour(s)`;
        }

        if (remainingHours > 0) {
            if (format.length !== 0) {
                format += ' ';
            }
            format += `${remainingHours} heure(s)`;
        }

        if (minuts > 0) {
            if (format.length !== 0) {
                format += ' ';
            }
            format += `${minuts} minute(s)`;
        }

        return format;
    }
}
